import axios from "axios";
import { baseURL } from "../Constants";

const url = `${baseURL}/SiteBanner`;

export interface SiteBanner {
    message: string;
    isActive: boolean;
    updatedAt: string;
    updatedBySteamId: string | null;
}

export const getSiteBanner = async (): Promise<SiteBanner> => {
    const response = await axios.get(url);
    return response.data;
};

export const setSiteBanner = async (
    message: string,
    isActive: boolean,
    token: string
): Promise<SiteBanner> => {
    const response = await axios.post(
        url,
        { message, isActive },
        { headers: { Authorization: `Bearer ${token}` } }
    );
    return response.data;
};
